




















import Component from 'vue-class-component';
import {Base} from "@/base";

@Component({
  name: 'NotificationList'
})
export default class NotificationList extends Base {
  clickToBell = false;
  // Computed
  get isActiveTrades() {
    const order = this.getActiveOrders.find(order => {
      const trade = this.getActiveTradesList.find(trade => trade.orderId === order.id);
      return trade && order.address === this.getWallet;
    });
    return order;
  }
  // Methods
  toggleBell() {
    if (this.isActiveTrades) {
      this.clickToBell = !this.clickToBell;
    }
  }
  redirectToMarketplace() {
    this.toggleBell();
    this.$router.push('/marketplace');
  }
};
